<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <h2>
          <v-icon class="mr-2">
            mdi-format-list-text
          </v-icon>
          発注（積替・搬入）
        </h2>
      </v-col>
    </v-row>

    <!-- ボタン -->
    <v-row>
      <v-col>
        <v-item-group v-model="selectedStatus">
          <v-row>
            <!-- 発注 -->
            <v-col>
              <v-item v-slot="{ active, toggle }" value="requested">
                <v-card
                  :color="active ? 'primary-gradients' : ''"
                  class="rounded-card"
                  @click="toggle"
                >
                  <v-card-text>
                    <v-row class="status-card">
                      <v-col
                        v-if="$vuetify.breakpoint.mdAndUp"
                        cols="12"
                        md="7"
                        class="image-col"
                      >
                        <v-layout :justify-center="true">
                          <v-img
                            max-height="90"
                            aspect-ratio="1"
                            contain
                            :src="
                              require(`@/assets/images/order/accept_statuses/carry_in_contact.png`)
                            "
                          />
                        </v-layout>
                      </v-col>
                      <v-col
                        cols="12"
                        md="5"
                        class="status-col"
                      >
                        <div
                          class="fill-width"
                          :class="active ? 'white--text' : ''"
                        >
                          <div
                            class="text-center font-weight-bold"
                            :class="
                              $vuetify.breakpoint.xlOnly ? '' : 'to-small-font'
                            "
                          >
                            <span :style="`line-height: ${$vuetify.breakpoint.smAndUp ? 3 : 1}`">発注</span>
                          </div>
                          <div class="text-center">
                            <span class="text-h5 font-weight-bold">
                              {{ summaries.requested_count }}
                            </span>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-item>
            </v-col>
            <!-- /発注 -->

            <!-- 受付 -->
            <v-col>
              <v-item v-slot="{ active, toggle }" value="ordered">
                <v-card
                  :color="active ? 'primary-gradients' : ''"
                  class="rounded-card"
                  @click="toggle"
                >
                  <v-card-text>
                    <v-row class="status-card">
                      <v-col
                        v-if="$vuetify.breakpoint.mdAndUp"
                        cols="12"
                        md="7"
                        class="image-col"
                      >
                        <v-layout :justify-center="true">
                          <v-img
                            max-height="90"
                            aspect-ratio="1"
                            contain
                            :src="
                              require(`@/assets/images/order/accept_statuses/carry_in_accept.png`)
                            "
                          />
                        </v-layout>
                      </v-col>
                      <v-col
                        cols="12"
                        md="5"
                        class="status-col"
                      >
                        <div
                          class="fill-width"
                          :class="active ? 'white--text' : ''"
                        >
                          <div
                            class="text-center font-weight-bold"
                            :class="
                              $vuetify.breakpoint.xlOnly ? '' : 'to-small-font'
                            "
                          >
                            <span :style="`line-height: ${$vuetify.breakpoint.smAndUp ? 3 : 1}`">受付</span>
                          </div>
                          <div class="text-center">
                            <span class="text-h5 font-weight-bold">
                              {{ summaries.ordered_count }}
                            </span>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-item>
            </v-col>
            <!-- /受付-->

            <!-- 配車済 -->
            <v-col v-if="isAllocate">
              <v-item
                v-slot="{ active, toggle }"
                value="dispatched"
              >
                <v-card
                  :color="active ? 'primary-gradients' : ''"
                  class="rounded-card"
                  @click="toggle"
                >
                  <v-card-text>
                    <v-row
                      class="status-card"
                    >
                      <v-col
                        v-if="$vuetify.breakpoint.mdAndUp"
                        cols="12"
                        md="7"
                        class="image-col"
                      >
                        <v-layout
                          :justify-center="true"
                        >
                          <v-img
                            max-height="90"
                            aspect-ratio="1"
                            contain
                            :src="
                              require(`@/assets/images/order/accept_statuses/allocation_completed.png`)
                            "
                          />
                        </v-layout>
                      </v-col>
                      <v-col
                        cols="12"
                        md="5"
                        class="status-col"
                      >
                        <div
                          class="fill-width"
                          :class="active ? 'white--text' : ''"
                        >
                          <div
                            class="text-center font-weight-bold"
                            :class="
                              $vuetify.breakpoint.xlOnly ? '' : 'to-small-font'
                            "
                          >
                            <span :style="`line-height: ${$vuetify.breakpoint.smAndUp ? 3 : 1}`">配車済</span>
                          </div>
                          <div class="text-center">
                            <span class="text-h5 font-weight-bold">
                              {{ summaries.dispatched_count }}
                            </span>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-item>
            </v-col>
            <!-- /配車済 -->

            <!-- 回収完了 -->
            <v-col v-if="isAllocate">
              <v-item
                v-slot="{ active, toggle }"
                value="collected"
              >
                <v-card
                  :color="active ? 'primary-gradients' : ''"
                  class="rounded-card"
                  @click="toggle"
                >
                  <v-card-text>
                    <v-row
                      class="status-card"
                    >
                      <v-col
                        v-if="$vuetify.breakpoint.mdAndUp"
                        cols="12"
                        md="7"
                        class="image-col"
                      >
                        <v-layout
                          :justify-center="true"
                        >
                          <v-img
                            max-height="90"
                            aspect-ratio="1"
                            contain
                            :src="
                              require(`@/assets/images/order/accept_statuses/transport_completed.png`)
                            "
                          />
                        </v-layout>
                      </v-col>
                      <v-col
                        cols="12"
                        md="5"
                        class="status-col"
                      >
                        <div
                          class="fill-width"
                          :class="active ? 'white--text' : ''"
                        >
                          <div
                            class="text-center font-weight-bold"
                            :class="
                              $vuetify.breakpoint.xlOnly ? '' : 'to-small-font'
                            "
                          >
                            <span :style="`line-height: ${$vuetify.breakpoint.smAndUp ? 3 : 1}`">回収完了</span>
                          </div>
                          <div class="text-center">
                            <span class="text-h5 font-weight-bold">
                              {{ summaries.collected_count }}
                            </span>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-item>
            </v-col>
            <!-- /回収完了 -->

            <!-- 登録完了 -->
            <v-col>
              <v-item
                v-slot="{ active, toggle }"
                value="completed"
              >
                <v-card
                  :color="active ? 'primary-gradients' : ''"
                  class="rounded-card"
                  @click="toggle"
                >
                  <v-card-text>
                    <v-row
                      class="status-card"
                    >
                      <v-col
                        v-if="$vuetify.breakpoint.mdAndUp"
                        cols="12"
                        md="7"
                        class="image-col"
                      >
                        <v-layout
                          :justify-center="true"
                        >
                          <v-img
                            max-height="90"
                            aspect-ratio="1"
                            contain
                            :src="
                              require(`@/assets/images/order/accept_statuses/register_completed.png`)
                            "
                          />
                        </v-layout>
                      </v-col>
                      <v-col
                        cols="12"
                        md="5"
                        class="status-col"
                      >
                        <div
                          class="fill-width"
                          :class="active ? 'white--text' : ''"
                        >
                          <div
                            class="text-center font-weight-bold"
                            :class="
                              $vuetify.breakpoint.xlOnly ? '' : 'to-small-font'
                            "
                          >
                            <span :style="`line-height: ${$vuetify.breakpoint.smAndUp ? 3 : 1}`">登録完了</span>
                          </div>
                          <div class="text-center">
                            <span class="text-h5 font-weight-bold">
                              {{ summaries.completed_count }}
                            </span>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-item>
            </v-col>
            <!-- /登録完了 -->

            <!-- キャンセル -->
            <v-col>
              <v-item
                v-slot="{ active, toggle }"
                value="canceled"
              >
                <v-card
                  :color="active ? 'primary-gradients' : ''"
                  class="rounded-card"
                  @click="toggle"
                >
                  <v-card-text>
                    <v-row
                      class="status-card"
                    >
                      <v-col
                        v-if="$vuetify.breakpoint.mdAndUp"
                        cols="12"
                        md="7"
                        class="image-col"
                      >
                        <v-layout
                          :justify-center="true"
                        >
                          <v-img
                            max-height="90"
                            aspect-ratio="1"
                            contain
                            :src="
                              require(`@/assets/images/order/accept_statuses/cancel.png`)
                            "
                          />
                        </v-layout>
                      </v-col>
                      <v-col
                        cols="12"
                        md="5"
                        class="status-col"
                      >
                        <div
                          class="fill-width"
                          :class="active ? 'white--text' : ''"
                        >
                          <div
                            class="text-center font-weight-bold"
                            :class="
                              $vuetify.breakpoint.xlOnly ? '' : 'to-small-font'
                            "
                          >
                            <span :style="`line-height: ${$vuetify.breakpoint.smAndUp ? 3 : 1}`">キャンセル</span>
                          </div>
                          <div class="text-center">
                            <span class="text-h5 font-weight-bold">
                              {{ summaries.canceled_count }}
                            </span>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-item>
            </v-col>
            <!-- /キャンセル -->
          </v-row>
        </v-item-group>
      </v-col>
    </v-row>
    <!-- /ボタン -->

    <!-- 検索項目 -->
    <v-row>
      <v-col>
        <v-expansion-panels
          v-model="panel"
        >
          <!-- ■■■条件を指定して検索 -->
          <v-expansion-panel>
            <v-expansion-panel-header class="panel-header-color panel-selectable">
              <strong>
                <v-icon class="panel-header-color">
                  mdi-magnify
                </v-icon>
                &nbsp;条件を指定して検索
              </strong>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card flat>
                <v-card-text>

                  <!-- 発注種別, 積替運搬日なし, 積替運搬日(from), 積替運搬日(to) -->
                  <v-row>
                    <v-col cols="12" md="2">
                      <v-select
                        v-model="searchForms.orderType"
                        :items="orderTypes"
                        dense
                        hide-details="auto"
                        label="発注種別"
                        clearable
                        outlined
                        persistent-placeholder
                        rounded
                        style="font-size: 80%"
                        @change="searchButtonClickEvent()"
                      />
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-select
                        v-model="searchForms.requestDateType"
                        :items="requestDateTypes"
                        background-color="white"
                        clearable
                        dense
                        hide-details="auto"
                        label="積替運搬日なし"
                        outlined
                        persistent-placeholder
                        rounded
                        style="font-size: 80%"
                        @change="searchButtonClickEvent()"
                      >
                      </v-select>
                    </v-col>
                    <v-col cols="12" md="2">
                      <cs-date-picker
                        :date.sync="searchForms.requestStartDate"
                        :disabled="searchForms.requestDateType === 'urgent' || searchForms.requestDateType === 'anytime'"
                        @dateChangedCallback="requestStartDateChangedCallback"
                      >
                        <template v-slot="{ on, attrs }">
                          <v-text-field
                            v-model="searchForms.requestStartDate"
                            :disabled="searchForms.requestDateType === 'urgent' || searchForms.requestDateType === 'anytime'"
                            v-bind="attrs"
                            v-on="on"
                            append-icon="mdi-calendar"
                            clearable
                            dense
                            hide-details="auto"
                            label="積替運搬日（From）"
                            outlined
                            persistent-hint
                            persistent-placeholder
                            placeholder="日付を選択"
                            readonly
                            rounded
                            style="font-size: 80%"
                            @click:clear="requestStartDateClearEvent"
                          >
                            <template v-slot:append-outer>
                              <div
                                v-if="$vuetify.breakpoint.mdAndUp"
                                style="vertical-align: middle"
                              >
                                〜
                              </div>
                            </template>
                          </v-text-field>
                        </template>
                      </cs-date-picker>
                    </v-col>
                    <v-col cols="12" md="2">
                      <cs-date-picker
                        :date.sync="searchForms.requestEndDate"
                        :disabled="searchForms.requestDateType === 'urgent' || searchForms.requestDateType === 'anytime'"
                        @dateChangedCallback="requestEndDateChangedCallback"
                      >
                        <template v-slot="{ on, attrs }">
                          <v-text-field
                            v-model="searchForms.requestEndDate"
                            :disabled="searchForms.requestDateType === 'urgent' || searchForms.requestDateType === 'anytime'"
                            v-bind="attrs"
                            v-on="on"
                            append-icon="mdi-calendar"
                            clearable
                            dense
                            hide-details="auto"
                            label="積替運搬日（To）"
                            outlined
                            persistent-hint
                            persistent-placeholder
                            placeholder="日付を選択"
                            readonly
                            rounded
                            style="font-size: 80%"
                            @click:clear="requestEndDateClearEvent"
                          />
                        </template>
                      </cs-date-picker>
                    </v-col>
                  </v-row>
                  <!-- /発注種別, 積替運搬日なし, 積替運搬日(from), 積替運搬日(to) -->

                  <!-- 搬入日(from), 搬入日(to) -->
                  <v-row>
                    <v-col cols="12" md="2">
                      <cs-date-picker
                        :date.sync="searchForms.carryInStartDate"
                        @dateChangedCallback="carryInStartDateChangedCallback"
                      >
                        <template v-slot="{ on, attrs }">
                          <v-text-field
                            v-model="searchForms.carryInStartDate"
                            v-bind="attrs"
                            v-on="on"
                            append-icon="mdi-calendar"
                            clearable
                            dense
                            hide-details="auto"
                            label="搬入日（From）"
                            outlined
                            persistent-hint
                            persistent-placeholder
                            placeholder="日付を選択"
                            readonly
                            rounded
                            style="font-size: 80%"
                            @click:clear="carryInStartDateClearEvent"
                          >
                            <template v-slot:append-outer>
                              <div
                                v-if="$vuetify.breakpoint.mdAndUp"
                                style="vertical-align: middle"
                              >
                                〜
                              </div>
                            </template>
                          </v-text-field>
                        </template>
                      </cs-date-picker>
                    </v-col>
                    <v-col cols="12" md="2">
                      <cs-date-picker
                        :date.sync="searchForms.carryInEndDate"
                        @dateChangedCallback="carryInEndDateChangedCallback"
                      >
                        <template v-slot="{ on, attrs }">
                          <v-text-field
                            v-model="searchForms.carryInEndDate"
                            v-bind="attrs"
                            v-on="on"
                            append-icon="mdi-calendar"
                            clearable
                            dense
                            hide-details="auto"
                            label="搬入日（To）"
                            outlined
                            persistent-hint
                            persistent-placeholder
                            placeholder="日付を選択"
                            readonly
                            rounded
                            style="font-size: 80%"
                            @click:clear="carryInEndDateClearEvent"
                          />
                        </template>
                      </cs-date-picker>
                    </v-col>
                  </v-row>
                  <!-- /搬入日(from), 搬入日(to) -->

                  <!-- 引取搬入番号, 運搬元・運搬業者・運搬先で検索, 運搬担当者 -->
                  <v-row>
                    <v-col cols="12" md="2">
                      <v-text-field
                        v-model="searchForms.requestNo"
                        prepend-inner-icon="mdi-magnify"
                        background-color="white"
                        clearable
                        dense
                        hide-details="auto"
                        label="引取搬入番号"
                        outlined
                        rounded
                        persistent-placeholder
                        style="font-size: 80%"
                        @blur="searchButtonClickEvent()"
                        @click:clear="searchForms.requestNo = null; searchButtonClickEvent()"
                      />
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="searchForms.keyword"
                        prepend-inner-icon="mdi-magnify"
                        background-color="white"
                        dense
                        hide-details="auto"
                        outlined
                        rounded
                        placeholder="運搬元・運搬業者・運搬先で検索"
                        style="font-size: 80%"
                        clearable
                        @blur="searchButtonClickEvent()"
                        @click:clear="searchForms.keyword = null; searchButtonClickEvent()"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="4"
                    >
                      <v-select
                        v-model="searchForms.driverId"
                        :items="drivers"
                        clearable
                        dense
                        hide-details="auto"
                        label="運搬担当者"
                        outlined
                        rounded
                        persistent-placeholder
                        style="font-size: 80%"
                        @change="searchButtonClickEvent()"
                      />
                    </v-col>
                  </v-row>
                  <!-- /引取搬入番号, 運搬元・運搬業者・運搬先で検索, 運搬担当者 -->

                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    color="primary"
                    @click="searchButtonClickEvent"
                  >
                    <v-icon>
                      mdi-magnify
                    </v-icon>
                    &nbsp;検索
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <!-- /条件を指定して検索 -->
        </v-expansion-panels>
      </v-col>
    </v-row>
    <!-- /検索項目 -->

    <!-- ボタン -->
    <v-row>
      <v-col class="text-right">
        <v-btn
          color="primary"
          class="text-h6"
          x-large
          @click="callPickingRequestDialog"
        >
          積替運搬
        </v-btn>
        &nbsp;
        <v-btn
          color="primary"
          class="text-h6"
          x-large
          @click="callCarryingRequestDialog"
        >
          搬入予約
        </v-btn>
      </v-col>
    </v-row>
    <!-- /ボタン -->

    <v-row>
      <v-col>
        <custom-pagination
          :page-number="page"
          :per-page="perPage"
          :pagination="pagination"
          :total-visible="totalVisible"
          @pageChanged="changePage"
          @perPageChanged="changePerPage"
        />
      </v-col>
    </v-row>

    <!-- 一覧 -->
    <v-row>
      <v-col>
        <v-card flat class="rounded-card">
          <v-data-table
            v-model="rowSelected"
            :headers="fixedTableHeader"
            :items="orders"
            :items-per-page="-1"
            hide-default-footer
            disable-sort
            show-select
            @click:row="toggleRowSelection"
          >
            <!-- ステータス -->
            <template v-slot:[`item.status`]="{ item }">
              <v-chip
                x-small
                label
                :color="item.status | status_chip_requests_color"
              >
                {{ item.status | status_to_label_order_request(item.temporarily) }}
              </v-chip>
              <v-tooltip
                  v-if='item.rejection_reason'
                  top
                  :open-on-hover="false"
                >
                  <template #activator="{ on }">
                    <v-btn
                      icon
                      small
                      retain-focus-on-click
                      @click="on.click"
                      @blur="on.blur"
                    >
                      <v-icon
                        small
                        class='error--text'
                      >
                        mdi-information-outline
                      </v-icon>
                    </v-btn>
                  </template>
                  <small>
                    {{ item.rejection_reason }}
                  </small>
                </v-tooltip>
                <div>
                  &nbsp;<small v-if="item.driver">{{ item.driver.name }}</small>
                </div>
            </template>
            <!-- ステータス -->

            <!-- オーダー番号/受注日 -->
            <template v-slot:[`item.order_no`]="{ item }">
              <div>
                {{ item.order_no }}&nbsp;
              </div>
              <small class="text--disabled">{{ item.order_date | date_format }}</small>
            </template>
            <!-- /オーダー番号/受注日 -->

            <!-- 引取搬入番号/引取予定日・搬入日 -->
            <template v-slot:[`item.request_no`]="{ item }">
              <div>
                {{ item.request_no }}&nbsp;
              </div>
              <small class="text--disabled">{{ item.request_date | date_format }}</small>
            </template>
            <!-- 引取搬入番号/引取予定日・搬入日 -->

            <!-- 運搬元(事業場) -->
            <template v-slot:[`item.tenant_location`]="{ item }">
              <template v-if="item.tenant_location.name">
                <div style="display: flex; align-items: flex-start;">
                  <div
                    :title="item.tenant_location.name"
                    class="line-clamp"
                    style="-webkit-line-clamp: 2; flex: 1;"
                  >
                    {{ item.tenant_location.name }}
                  </div>
                  <v-tooltip
                    top
                    :open-on-hover="false"
                  >
                    <template #activator="{ on }">
                      <v-btn
                        icon
                        tile
                        small
                        retain-focus-on-click
                        @click="on.click"
                        @blur="on.blur"
                        class="pb-2"
                      >
                        <v-icon small>mdi-map-marker-outline</v-icon>
                      </v-btn>
                    </template>
                    <div>
                      <strong>{{ item.tenant_location.name }}</strong>
                      <br />
                      <small>{{ item.tenant_location.address }}</small>
                    </div>
                  </v-tooltip>
                </div>
              </template>
            </template>
            <!-- /運搬元(事業場) -->

            <!-- 運搬業者 -->
            <template v-slot:[`item.transporter`]="{ item }">
              <template v-if="item.transporter.name">
                <div class="line-clamp one-clamp float-left" style="max-width: 80%;width: auto;">
                  {{ item.transporter.name }}
                </div>
                <v-tooltip
                  top
                  :open-on-hover="false"
                >
                  <template #activator="{ on }">
                    <v-btn
                      icon
                      tile
                      small
                      retain-focus-on-click
                      @click="on.click"
                      @blur="on.blur"
                      class="pb-2"
                    >
                      <v-icon small>mdi-map-marker-outline</v-icon>
                    </v-btn>
                  </template>
                  <div>
                    <strong>{{ item.transporter.name }}</strong>
                     <br />
                    <small>{{ item.transporter.address }}</small>
                  </div>
                </v-tooltip>
              </template>
            </template>
            <!-- /運搬業者 -->

            <!-- 運搬先 -->
            <template v-slot:[`item.trader`]="{ item }">
              <div style="display: flex; align-items: flex-start;">
                <div
                  :title="item.trader.name"
                  class="line-clamp"
                  style="-webkit-line-clamp: 2; flex: 1;"
                >
                  {{ item.trader.name }}
                </div>
                <v-tooltip
                  top
                  :open-on-hover="false"
                >
                  <template #activator="{ on }">
                    <v-btn
                      icon
                      tile
                      small
                      retain-focus-on-click
                      @click="on.click"
                      @blur="on.blur"
                      class="pb-2"
                    >
                      <v-icon small>mdi-map-marker-outline</v-icon>
                    </v-btn>
                  </template>
                  <div>
                    <strong>{{ item.trader.location.name }}</strong>
                    <br />
                    <small>{{ item.trader.location.address }}</small>
                  </div>
                </v-tooltip>
              </div>
            </template>
            <!-- /運搬先 -->

            <!-- 排出業者 -->
            <template v-slot:[`item.emission`]="{ item }">
              <div
                :title="item.emission?.name"
                class="line-clamp one-clamp"
              >
                {{ item.emission?.name }}&nbsp;
              </div>
              <div>
                <small v-if="item.total_emission_count > 0">全&nbsp;{{ item.total_emission_count }}件</small>
              </div>
            </template>
            <!-- /排出業者 -->

            <!-- 品目/荷姿 -->
            <template v-slot:[`item.item`]="{ item }">
              <div>
                <v-chip
                  v-if="item.item_name"
                  :title="item.item_name"
                  color="#F0E6D0"
                  drak
                  label
                  x-small
                >
                  {{ item.item_name | truncate(10) }}
                </v-chip>
              </div>
              <small>{{ item.packing_name }}<span v-if="item.total_items_count > 0">&emsp;全&nbsp;{{ item.total_items_count }}件</span></small>
            </template>
            <!-- /品目/荷姿 -->

            <!-- マニフェスト -->
            <template v-slot:[`item.manifest`]="{ item }">
              <small>{{ item.manifest_no }}&nbsp;</small>
              <div v-if="item.total_manifests_count > 0"><small>全&nbsp;{{ item.total_manifests_count }}件</small></div>
            </template>
            <!-- /マニフェスト -->

            <!-- 編集 -->
            <template v-slot:[`item.editable`]="{ item }">
              <v-menu>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-dots-horizontal</v-icon>
                  </v-btn>
                </template>
                {{ item.name }}
                <v-list dense>
                  <v-list-item
                    v-if="['pickup_requested', 'carry_in_contacted'].includes(item.status)"
                    link
                    @click="editButtonClickEvent(item)"
                  >
                    <v-list-item-title>
                      編集
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="!['pickup_requested', 'carry_in_contacted'].includes(item.status)"
                    link
                    @click="showButtonClickEvent(item)"
                  >
                    <v-list-item-title>
                      詳細を参照
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="item.can_directly_complete"
                    link
                    @click="directlyCompleteButtonClickEvent(item)"
                  >
                    <v-list-item-title> 登録完了にする </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="item.can_delete"
                    link
                    @click="cancelButtonClickEvent(item)"
                  >
                    <v-list-item-title>
                      <strong class="error--text">
                        削除
                      </strong>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
            <!-- 編集 -->

          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <!-- /一覧 -->

    <!-- ページャー -->
    <v-row class="mb-15">
      <v-col>
        <custom-pagination
          :page-number="page"
          :per-page="perPage"
          :pagination="pagination"
          :total-visible="totalVisible"
          @pageChanged="changePage"
          @perPageChanged="changePerPage"
        />
      </v-col>
    </v-row>
    <!-- /ページャー -->

    <v-footer fixed class="mb-13" color="white" width="100%">
      <v-card flat width="100%">
        <v-card-actions>
          <v-spacer />
          <!-- 受渡確認票出力 -->
          <v-btn
            color="info"
            :disabled="rowSelected.length <= 0"
            @click="outputManifestButtonClickEvent"
          >
            受渡確認票出力
          </v-btn>&emsp;
          <!-- /受渡確認票出力 -->
          <v-menu :disabled="rowSelected.length <= 0">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :disabled="rowSelected.length <= 0"
                class="mr-3"
                color="primary"
                v-bind="attrs"
                v-on="on"
              >
                運搬終了報告
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item
                link
                @click="completionReportDialogClickEvent"
              >
                <v-list-item-title>
                  個別登録
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                link
                @click="bulkCompletionReportDialogClickEvent"
              >
                <v-list-item-title>
                  一括登録
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-card-actions>
      </v-card>
    </v-footer>


    <confirm ref="confirm" />

    <!-- 積替運搬 -->
    <picking-request-dialog
      :enable-dialog="enablePickingRequestDialog"
      @cancelCallback="dialogCloseCallback"
      @registerCallback="pickingRequestRegisterCallback"
    />
    <!-- 運搬報告 -->
    <carrying-request-dialog
      :enable-dialog="enableCarryingRequestDialog"
      @cancelCallback="dialogCloseCallback"
      @registerCallback="carryingRequestRegisterCallback"
    />
    <!-- 運搬終了報告(個別) -->
    <completion-report-dialog
      :enable-dialog="enableCompletionDialog"
      type="Requests"
      :order-ids="targetOrderIds"
      :manifest-ids="targetManifestIds"
      @cancelCallback="dialogCloseCallback"
      @registerEvent="editDialogRegisterCallback"
    />
    <!-- /運搬終了報告(個別) -->
    <!-- 運搬終了報告(一括) -->
    <bulk-completion-dialog
      :enable-dialog="enableBulkCompletionDialog"
      type="Requests"
      :order-ids="targetOrderIds"
      :manifest-ids="targetManifestIds"
      @cancelCallback="dialogCloseCallback"
      @registerEvent="editDialogRegisterCallback"
    />
    <!-- /運搬終了報告(一括) -->
    <!-- アップグレード誘導モーダル -->
    <ec-contract-single-plan-guide-dialog
      :enable-dialog="enableEcContractSinglePlanGuideDialog"
      :from-request="true"
      @closeCallback="dialogCloseCallback"
    />
    <!-- /アップグレード誘導モーダル -->
    <v-dialog
      v-model="enableWarningDialog"
      persistent
      width="500"
    >
      <v-card>
        <v-card-title class="text-h5 red darken-2 white--text">
          確認
        </v-card-title>
        <v-divider />
        <v-card-text>
          <h4 class="mt-4">
            {{ warningDialogMessage }}
          </h4>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            @click="enableWarningDialog = false"
          >
            閉じる
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import CarryingRequestDialog from './dialogs/_CarryingRequestDialog'
import PickingRequestDialog from './dialogs/_PickingRequestDialog'
import CompletionReportDialog from '../../dialogs/_CompletionReportDialog'
import BulkCompletionDialog from '../../dialogs/_BulkCompletionReportDialog'
import Confirm from '../../../../components/Confirm'
import CustomPagination from "@/driver/components/_CustomPagination.vue";
import EcContractSinglePlanGuideDialog from '../../dialogs/_EcContractSinglePlanGuideDialog'

export default {
  name: 'DriverOrderRequests',
  components: {
    CustomPagination,
    CarryingRequestDialog,
    PickingRequestDialog,
    CompletionReportDialog,
    BulkCompletionDialog,
    EcContractSinglePlanGuideDialog,
    Confirm
  },
  mixins: [],
  props: {},
  data() {
    return {
      panel: null,
      page: 1,
      perPage: 50,
      totalVisible: 7,
      selectedStatus: null,
      rowSelected: [],
      summaries: {
        requested_count: 0,
        ordered_count: 0,
        dispatched_count: 0,
        collected_count: 0,
        completed_count: 0,
        canceled_count: 0,
      },
      searchForms: {
        requestNo: null,
        keyword: null,
        driverId: null,
        driverName: null,
        requestDateType: null,
        requestStartDate: null,
        requestEndDate: null,
        orderType: null,
        carryInStartDate: null,
        carryInEndDate: null,
      },
      /** 発注種別 */
      orderTypes: [
        { value: 'carryin', text: '積替運搬' },
        { value: 'pickup', text: '搬入予約' },
      ],
      /** 積替運搬日の状態 */
      requestDateTypes: [
        { value: 'urgent', text: '至急'},
        { value: 'anytime', text: '指定なし' }
      ],
      fixedTableHeader: [],
      orders: [],
      drivers: [],
      enableCarryingRequestDialog: false,
      enablePickingRequestDialog: false,
      enableCompletionDialog: false,
      enableBulkCompletionDialog: false,
      enableEcContractSinglePlanGuideDialog: false,
      selectedIds: [],
      manifestCount: null,
      totalAmount: null,
      targetOrderIds: [],
      targetManifestIds: [],
      enableWarningDialog: false,
      warningDialogMessage: null,
    }
  },
  computed: {
    ...mapState('DriverOrderRequest', {
      pagination: 'pagination',
      searchCondition: 'condition',
    }),
    ...mapGetters('DriverOrderRequest', [
      'hasResult'
    ]),
    ...mapState('DriverTenantConfiguration', {
      isAllocate: 'use_allocate',
      isEcContractSinglePlan: 'use_ec_contract_single_plan',
    }),
  },
  watch: {
    'selectedStatus' (newStatus) {
      this.changeSelectedStatus(newStatus)
    }
  },
  created() {
    if (this.$route.params.resetCondition) {
      this.resetState()
    }
    if (this.$route.params.resetPagination) {
      this.resetPagination()
    }
    this.selectedStatus = this.searchCondition.selectedStatus
    this.searchForms.requestNo = this.searchCondition.requestNo
    this.searchForms.keyword = this.searchCondition.keyword
    this.searchForms.driverId = this.searchCondition.driverId
    this.searchForms.driverName = this.searchCondition.driverName
    this.searchForms.requestDateType = this.searchCondition.requestDateType
    this.searchForms.requestStartDate = this.searchCondition.requestStartDate
    this.searchForms.requestEndDate = this.searchCondition.requestEndDate
    this.searchForms.orderType = this.searchCondition.orderType
    this.searchForms.carryInStartDate = this.searchCondition.carryInStartDate
    this.searchForms.carryInEndDate = this.searchCondition.carryInEndDate

    this.buildTableHeader()

    this.fetchDrivers().then((content) => {
      this.drivers = content.drivers
    })

    this.page = this.pagination.current_page
    this.perPage = this.searchCondition.limit
    this.searchOrderRequests()
  },
  methods: {
    ...mapActions('DriverOrderReportConfirmationVerification', {
      verification: 'show',
    }),
    ...mapActions("DriverOrderConfirmationSlipVerification", {
      slipVerification: "show",
    }),
    ...mapActions('DriverOrderRequest', {
      fetchOrderRequest: 'index',
      deleteOrderRequest: 'destroy',
      resetState: 'resetState',
      resetPagination: 'resetPagination',
    }),
    ...mapActions('DriverOrderSummary', {
      fetchOrderSummaries: 'index',
    }),
    ...mapActions('DriverMasterSearchDriver', {
      fetchDrivers: 'index'
    }),
    ...mapActions("DriverOrderRequestsDirectlyComplete", {
      directlyComplete: "update"
    }),
    buildTableHeader() {
      this.fixedTableHeader = [
        { text: 'ステータス\r\nドライバー', value: 'status', width: '11%', align: 'left' },
        { text: "積替搬入番号\r\n積替運搬日・搬入日", value: 'request_no', align: 'center', width: '10%' },
        { text: '運搬元（事業場）',value: 'tenant_location', width: '14%' },
        { text: '運搬業者', value: 'transporter', width: '14%'  },
        { text: '運搬先', value: 'trader', width: '14%' },
        { text: '排出事業者', value: 'emission', width: '14%' },
        { text: '取扱品目\r\n荷姿', value: 'item', width: '11%' },
        { text: 'マニフェスト', value: 'manifest', width: '7%' },
        { text: '編集', value: 'editable', align: 'end', width: '5%' },
      ]
      if (!this.isAllocate) {
        this.fixedTableHeader = this.fixedTableHeader.filter( v => v.value !== 'driver' )
      }
    },
    /**
     * 検索ボタン クリックイベント
     */
    searchButtonClickEvent () {
      this.page = 1
      this.searchOrderRequests()
    },
    /**
     * 新規登録ボタン クリックイベント
     */
    addButtonClickEvent () {
      this.$router.push({name: 'DriverOrderRequestNew'})
    },
    /**
     * ダイアログ 閉じるボタンコールバック
     */
    dialogCloseCallback () {
      this.enableCompletionDialog = false
      this.enableBulkCompletionDialog = false
      this.enableCarryingRequestDialog = false
      this.enablePickingRequestDialog = false
      this.enableEcContractSinglePlanGuideDialog = false
    },
    /**
     * ページ チェンジイベント
     */
    changePage(page) {
      this.page = page;
      this.searchOrderRequests()
    },
    changePerPage (perPage) {
      this.perPage = perPage
      this.page = 1
      this.searchOrderRequests()
    },
    /**
     * 行選択トグル
     */
    toggleRowSelection(item) {
      const index = this.rowSelected.findIndex(row => row === item);
      if (index > -1) {
        // 既に選択されている場合は削除
        this.rowSelected.splice(index, 1);
      } else {
        // 選択されていない場合は追加
        this.rowSelected.push(item);
      }
    },
    /**
     * 運搬終了報告 個別登録ボタン
     */
    completionReportDialogClickEvent () {
      this.targetOrderIds = []
      for (const argument of this.rowSelected) {
        this.targetOrderIds.push(argument.id)
      }
      const params = { ids: this.targetOrderIds.join(','), report_type: 'completion', display_type: 'Requests' }
      this.warningDialogMessage = null
      this.verification({params: params}).then((content) => {
        if (content.status === 'success') {
          this.targetManifestIds = content.manifest_ids
          this.enableCompletionDialog = true
        } else {
          this.warningDialogMessage = content.error_message
          this.enableWarningDialog = true
        }
      })
    },
    directlyCompleteButtonClickEvent (item) {
      let modalOption = {
        title: "登録完了",
        message: "登録完了に更新します。よろしいですか？",
        options: { width: 450, isCancelButton: true },
      }
      this.$refs.confirm.open(modalOption).then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          this.directlyComplete({id: item.id}).then(() => {
            this.searchOrders()
          })
        }
      })
    },
    /**
     * 運搬終了報告 一括登録ボタン
     */
    bulkCompletionReportDialogClickEvent () {
      this.targetOrderIds = []
      this.targetManifestIds = []
      for (const argument of this.rowSelected) {
        this.targetOrderIds.push(argument.id)
      }
      const params = { ids: this.targetOrderIds.join(','), report_type: 'completion', is_bulk: true, display_type: 'Requests' }
      this.warningDialogMessage = null
      this.verification({params: params}).then((content) => {
        if (content.status === 'success') {
          this.targetManifestIds = content.manifest_ids
          this.enableBulkCompletionDialog = true
        } else {
          this.warningDialogMessage = content.error_message
          this.enableWarningDialog = true
        }
      })
    },
    /**
    * 搬入予約ボタン クリックイベント
    */
    callCarryingRequestDialog () {
      /** 電子契約単体プランの場合、メッセージを出して終わる */
      if (this.isEcContractSinglePlan) {
        this.enableEcContractSinglePlanGuideDialog = true
      } else {
        this.enableCarryingRequestDialog = true
      }
    },
    /**
    * 引取連絡ボタン クリックイベント
    */
    callPickingRequestDialog () {
      /** 電子契約単体プランの場合、メッセージを出して終わる */
      if (this.isEcContractSinglePlan) {
        this.enableEcContractSinglePlanGuideDialog = true
      } else {
        this.enablePickingRequestDialog = true
      }
    },
    /**
    * 搬入予約 登録ボタンコールバック
    */
    carryingRequestRegisterCallback () {
      this.dialogCloseCallback()
      this.searchOrderRequests()
    },
    /**
    * 引取連絡 登録ボタンコールバック
    */
    pickingRequestRegisterCallback () {
      this.dialogCloseCallback()
      this.searchOrderRequests()
    },
    /**
     * 運搬終了報告 登録ボタンコールバック
     */
    editDialogRegisterCallback () {
      this.dialogCloseCallback()
      this.searchOrderRequests()
    },
    /**
     * 検索処理実行
     */
    searchOrderRequests () {
      this.rowSelected = null;
      this.rowSelected = [];
      let params = this.buildParam()
      this.fetchOrderSummaries().then((content) => {
        this.summaries = content
      })
      this.fetchOrderRequest(params).then((content) => {
        this.orders = content.orders
      })
    },
    /**
     * 検索パラメータの生成
     */
    buildParam () {
      return {
        selectedStatus: this.selectedStatus,
        requestNo: this.searchForms.requestNo,
        keyword: this.searchForms.keyword,
        driverId: this.searchForms.driverId,
        driverName: this.searchForms.driverName,
        requestDateType: this.searchForms.requestDateType,
        requestStartDate: this.searchForms.requestStartDate,
        requestEndDate: this.searchForms.requestEndDate,
        orderType: this.searchForms.orderType,
        carryInStartDate: this.searchForms.carryInStartDate,
        carryInEndDate: this.searchForms.carryInEndDate,
        page: this.page,
        limit: this.perPage,
      }
    },
    /**
     * 削除ボタン クリックイベント
     * @param item
     */
    cancelButtonClickEvent (item) {
      let modalOption = { title: '削除', message: '削除しますがよろしいですか？', options: { width: 320, titleColor: 'red', isCancelButton: true } }
      this.$refs.confirm.open(modalOption).then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          this.deleteOrderRequest({ id: item.id }).then(() => {
            this.rowSelected = null
            this.rowSelected = []
            this.searchOrderRequests()
          })
        }
      })
    },
    /**
     * 受渡確認票出力ボタン クリックイベント
     * @description 受渡確認票を別タブにて表示する
     */
    outputManifestButtonClickEvent () {
      let selectedIds = this.rowSelected.map(v=>v.id)
      const params = {
        targets: selectedIds
      };
      this.slipVerification({ params: params }).then((content) => {
        if (content.status === "success") {
          let resolvedRoute = this.$router.resolve({
            name: 'DriverOrderConfirmationSlips',
            query: { targets: selectedIds }
          })
          window.open(resolvedRoute.href, '_blank');
        } else {
          this.warningDialogMessage = content.error_message;
          this.enableWarningDialog = true;
        }
      });
    },
    /**
     * 編集ボタン クリックイベント
     */
    editButtonClickEvent (item) {
      if (item.status === 'pickup_requested') {
        this.$router.push({name: 'DriverOrderRequestPickupEdit', params: {id: item.id}})
      } else {
        this.$router.push({name: 'DriverOrderRequestCarryInEdit', params: {id: item.id}})
      }
    },
    /**
    * 詳細を参照ボタン クリックイベント
    */
    showButtonClickEvent (item) {
      if (item.status.match(/^pickup/)) {
        this.$router.push({name: 'DriverOrderRequestPickup', params: {id: item.id}})
      } else {
        this.$router.push({name: 'DriverOrderRequestCarryIn', params: {id: item.id}})
      }
    },
    /**
    * ステータス選択ボタン クリックイベント
    */
    changeSelectedStatus(newStatus) {
      if (newStatus === undefined) {
        this.selectedStatus = ''
      }
      this.rowSelected = null
      this.rowSelected = []
      this.page = 1
      this.searchOrderRequests()
    },
    /**
     * 積替運搬日（from）変更　コールバック
     */
    requestStartDateChangedCallback (value) {
      this.searchForms.requestStartDate = value;
      this.searchButtonClickEvent();
    },
    /**
     * 積替運搬日（to）変更　コールバック
     */
    requestEndDateChangedCallback (value) {
      this.searchForms.requestEndDate = value;
      this.searchButtonClickEvent();
    },
    /**
     * 搬入日（from）変更　コールバック
     */
    carryInStartDateChangedCallback (value) {
      this.searchForms.carryInStartDate = value;
      this.searchButtonClickEvent();
    },
    /**
     * 搬入日（to）変更　コールバック
     */
    carryInEndDateChangedCallback (value) {
      this.searchForms.carryInEndDate = value;
      this.searchButtonClickEvent();
    },
    requestStartDateClearEvent () {
      this.searchForms.requestStartDate = null;
      this.searchButtonClickEvent();
    },
    requestEndDateClearEvent () {
      this.searchForms.requestEndDate = null;
      this.searchButtonClickEvent();
    },
    carryInStartDateClearEvent () {
      this.searchForms.carryInStartDate = null;
      this.searchButtonClickEvent();
    },
    carryInEndDateClearEvent () {
      this.searchForms.carryInEndDate = null;
      this.searchButtonClickEvent();
    },

  }
}
</script>
<style lang="scss">
.v-input--reverse .v-input__slot {
  flex-direction: row-reverse;
  justify-content: flex-end;
  .v-application--is-ltr & {
    .v-input--selection-controls__input {
      margin-right: 0;
      margin-left: 8px;
    }
  }
  .v-application--is-rtl & {
    .v-input--selection-controls__input {
      margin-left: 0;
      margin-right: 8px;
    }
  }
}
</style>
<style scoped lang="scss">

.status-card {
  & .image-col {
    padding-top: 0;padding-bottom: 0;
    display: inline-flex;
  }
  & .status-col {
    padding-left: 0;padding-right: 0;
  }
}

.panel-header-color {
  color: #0D74BA !important;
  & .v-expansion-panel-header__icon {
    & .v-icon {
      color: #0D74BA !important;
    &::before {
        color: #0D74BA !important;
      }
    }
  }
}
.panel-selectable {
  background-color: #DCE7EB;
}

.v-tooltip__content {
  opacity: 1!important;
  background-color: #ffffff !important;
  border: 1px solid #dddddd !important;
  color: #565656 !important;
}

</style>
